import modules from './sitemap'
import notFound from '@/components/GeneralViews/NotFound.vue'

const bundle = {}

function pack(eventHandler) {
  return include(modules, eventHandler)
}

function include(components, eventHandler, pack) {
  Object.keys(components).forEach(key => {
    let module = (pack ? pack + '/' : '') + key

    if (components[key].subtabs) {
      include(components[key].subtabs, eventHandler, key)
    }

    bundle[module] = () => import(
      /* webpackChunkName: "documentation" */
      /* webpackMode: "lazy-once" */
      `@/../docs/${module}/index.vue`
    ).catch((e) => {
      console.warn('Doc not found')
      bundle[module] = notFound
      bundle[module].on = eventHandler

      const currentPath = global.app.$router.currentRoute.path
      global.app.$router.push({name: '404'})
      global.app.$router.push(currentPath)
      global.app.$loading = false
    })
    bundle[module].on = eventHandler
  })

  return bundle
}

export default { pack }



// WEBPACK FOOTER //
// ./docs/pack.js